import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/use-auth';

// Cache the mentor's access for the session so the nav doesn't refetch on every route.
let _cache = null;
export const clearMentorCache = () => { _cache = null; };

export const useMentorAccess = () => {
  const { user, authedFetch } = useAuth();
  const [data, setData] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (user?.persona !== 'mentor') { setLoading(false); return; }
    if (_cache) { setData(_cache); setLoading(false); return; }
    let active = true;
    authedFetch('/api/mentor/me')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (active && d) { _cache = d; setData(d); } })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [user, authedFetch]);

  return {
    mentor: data?.mentor || null,
    modules: data?.access?.modules || [],
    capabilities: data?.access?.capabilities || [],
    loading,
  };
};

export default useMentorAccess;
